<template>
    <form class="form" @submit.prevent="submitHandler">
        <div class="form__row">
            <div class="form__title">
                {{ $t("form.email") }}
            </div>
            <div class="form__field">
                <text-field
                        v-model.trim="clientLogin.email"
                        :v="$v.clientLogin.email"
                        :isHideBg="true"
                        :placeholder="$t('form.email')"
                        type="text"
                />
            </div>
        </div>
        <div class="form__row">
            <div class="form__title">
                {{ $t("form.password") }}
            </div>
            <div class="form__field">
                <text-field
                        v-model.trim="clientLogin.password"
                        :v="$v.clientLogin.password"
                        :isHideBg="true"
                        :placeholder="$t('form.password_placeholder')"
                        type="password"
                />
            </div>
        </div>
        <div class="form__action">
            <button type="submit" class="btn btn-w100 btn-gradient">
                <span> {{ $t("form.login") }}</span>
            </button>
        </div>
    </form>
</template>

<script>
    import textField from "@/elements/textField";
    import validate from "@/mixins/validate";
    export default {
        mixins: [validate],
        components: {
            textField
        },
        data() {
            return {
                clientLogin: {
                    email: '',
                    password: ''
                }
            }
        },
        methods: {
            async submitHandler() {
                this.$v.clientLogin.$touch();
                if (!this.$v.clientLogin.$invalid) {
                    let {email, password} = this.clientLogin;
                    let data = await this.$store.dispatch('STUDIO_MAKE_AUTH', {email: email, password: password})
                    if(data) this.$router.push('/studios/dashboard')
                }
            },
        },
    }
</script>
<style lang="sass" scoped>
    .form
        margin: 26px 0 30px 0
        &__title
            font-size: 16px
            +medium
        &__field
            margin-top: 6px
        &__action
            margin-top: 28px
</style>